module.exports = __webpack_public_path__ + "img/language-cn.2b6f8b2b.png";